const INTENSITY_RANKS = {
    '': 0,
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
    '5-': 5,
    '5+': 6,
    '6-': 7,
    '6+': 8,
    '7': 9
};

const INTENSITY_COLORS = {
    '1': '#6bc7ff',
    '2': '#4fa8ff',
    '3': '#f5de59',
    '4': '#f6a23c',
    '5-': '#ef6b3b',
    '5+': '#d94841',
    '6-': '#b83d7d',
    '6+': '#8b2f8f',
    '7': '#5b1a75'
};

export function escapeHTML(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function normalizeEarthquakeIntensity(value) {
    const rawValue = String(value ?? '').trim();

    if (!rawValue) {
        return '';
    }

    return rawValue
        .replace(/\s+/g, '')
        .replace('弱', '-')
        .replace('強', '+');
}

export function getEarthquakeIntensityLabel(value) {
    const normalizedValue = normalizeEarthquakeIntensity(value);

    return normalizedValue
        .replace('5-', '5弱')
        .replace('5+', '5強')
        .replace('6-', '6弱')
        .replace('6+', '6強');
}

export function getEarthquakeIntensityRank(value) {
    return INTENSITY_RANKS[normalizeEarthquakeIntensity(value)] || 0;
}

export function getEarthquakeIntensityColor(value) {
    return INTENSITY_COLORS[normalizeEarthquakeIntensity(value)] || '#5c7187';
}

export function formatEarthquakeDateTime(value, withSeconds = true) {
    if (!value) {
        return '';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return String(value);
    }

    const year = date.getFullYear(),
        month = `0${date.getMonth() + 1}`.slice(-2),
        day = `0${date.getDate()}`.slice(-2),
        hours = `0${date.getHours()}`.slice(-2),
        minutes = `0${date.getMinutes()}`.slice(-2),
        seconds = `0${date.getSeconds()}`.slice(-2);

    return withSeconds ?
        `${year}/${month}/${day} ${hours}:${minutes}:${seconds}` :
        `${year}/${month}/${day} ${hours}:${minutes}`;
}

export function buildEarthquakeButtonSummary(earthquake) {
    if (!earthquake) {
        return '';
    }

    return [
        formatEarthquakeDateTime(
            earthquake.origintime || earthquake.occurrence_datetime || earthquake.report_datetime,
            false
        ),
        earthquake.hypocentername || ''
    ].filter(Boolean).join(' ');
}
